import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import "./game.css";
import Header from "../components/Header";

function Pvp() {
    const navigate = useNavigate();

    // Khai báo các State
    const [isLoading, setLoading] = useState(false);
    const [profile, setProfile] = useState(null);
    const [playGame, setPlayGame] = useState(null);
    const [sanh, setSanh] = useState(null);
    const [product, setProduct] = useState(null);
    const [game, setGame] = useState([]); 
    const [activeOption, setActiveOption] = useState("0");
    const [searchTerm, setSearchTerm] = useState("");
    
    // State cho phân trang
    const [currentPage, setCurrentPage] = useState(1);
    const gamesPerPage = 30;

    // Cấu hình Axios Interceptor
    useEffect(() => {
        const interceptor = axios.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem("user");
                if (token) {
                    config.headers["Authorization"] = `Bearer ${token}`;
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );
        return () => axios.interceptors.request.eject(interceptor);
    }, []);

    // Hàm chạy ngầm rút tiền nếu phiên trước kẹt
    const autoRecoverMoney = (productType) => {
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: productType })
            .then((res) => {
                const currentBalance = res.data.data.balance;
                if (currentBalance > 0) {
                    return axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                        product_type: productType,
                        type: 2,
                        money: Math.floor(currentBalance)
                    });
                }
                return Promise.resolve();
            })
            .then(() => {
                localStorage.removeItem("playing_product");
                return axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`);
            })
            .then((res) => {
                if (res && res.data && res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => console.log("Lỗi tự động thu hồi tiền phiên cũ:", err));
    };

    // Load User & Check Kẹt Tiền
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                setProfile(res.data.data);
                localStorage.setItem("profile", JSON.stringify(res.data.data));

                const interruptedProduct = localStorage.getItem("playing_product");
                if (interruptedProduct) {
                    autoRecoverMoney(interruptedProduct);
                }
            })
            .catch((err) => {
                localStorage.removeItem("user");
            });

        // Load danh sách game mặc định (V8 POKER - type PVP) khi mới vào
        handleOptionClick("0", "102", "PVP");
    }, []);

    // Chặn Back
    useEffect(() => {
        const handlePopState = (event) => {
            if (playGame) {
                handleCloseGame();
            }
        };
        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
    }, [playGame, product]);

    function isMobileDevice() {
        if (window.innerWidth < 800) return true;
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    // Xử lý Lấy Danh Sách Game Con
    const handleOptionClick = (option, product_type, game_type) => {
        setActiveOption(option);
        setGame([]); 
        setSearchTerm(""); 
        setCurrentPage(1); 
        setLoading(true);
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/getgamelist`, { product_type, game_type })
            .then((res) => {
                if (res.data.data.length === 0) {
                    setLoading(false);
                    swal("Thông báo", "Sảnh game bảo trì", "error").then(() => setGame([]));
                } else {
                    setGame(res.data.data[0]);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLoading(false);
                swal("Thông báo", "Sảnh game bảo trì", "error").then(() => setGame([]));
            });
    };

    // Xử lý tìm kiếm
    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    // Ẩn game nếu ảnh bị lỗi
    function handleImageError(e) {
        const cardElement = e.target.closest('.pvp-card');
        if (cardElement) {
            cardElement.style.display = 'none';
        }
    }

    // HÀM KHỞI CHẠY GAME
    function launchGame(params) {
        if (localStorage.getItem("profile") == null || localStorage.getItem("profile") === "undefined") {
            navigate("/login");
            return;
        }
        if (isLoading === true) return;

        const form = {
            ...params,
            platform: isMobileDevice() === true ? "html5" : "html5-desktop"
        };

        setLoading(true);

        let a;
        switch (params.product_type) {
            case "4": a = "AG"; break;
            case "79": a = "BBIN"; break;
            case "104": a = "CMD"; break;
            case "16": a = "CQ9"; break;
            case "27": a = "DG"; break;
            case "86": a = "Evolution"; break;
            case "142": a = "FB"; break;
            case "140": a = "JILI"; break;
            case "121": a = "KingMaker"; break;
            case "102": a = "V8 Poker"; break;
            case "123": a = "King Poker"; break;
            case "43": a = "MG"; break;
            case "39": a = "PP"; break;
            case "174": a = "SABA"; break;
            case "118": a = "WM"; break;
            case "112": a = "SEXY"; break;
            case "54": a = "SBO"; break;
            case "151": a = "UG"; break;
            case "98": a = "PG"; break;
            case "99": a = "TF"; break;
            case "3": a = "Playtech"; break;
            case "28": a = "AllBet"; break;
            case "55": a = "JDB"; break;
            case "202": a = "WS168"; break;
            case "61": a = "IMES"; break;
            case "132": a = "SV388"; break;
            default: a = ""; break;
        }
        setSanh(a);
        setProduct(params.product_type);

        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/launchgame`, form)
            .then((res) => {
                if (res.data.data.status === 0) {
                    const gameUrl = res.data.data.game_url;

                    if (profile && profile.money > 0) {
                        const amountToTransfer = Math.floor(profile.money);
                        const autoTransferData = {
                            product_type: params.product_type,
                            type: 1,
                            money: amountToTransfer
                        };

                        axios
                            .post(`${process.env.REACT_APP_API_URL}/casino/transfer`, autoTransferData)
                            .then(() => {
                                axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`).then((userRes) => {
                                    setProfile(userRes.data.data);
                                    localStorage.setItem("profile", JSON.stringify(userRes.data.data));
                                    localStorage.setItem("playing_product", params.product_type);
                                    window.history.pushState({ inGame: true }, "");

                                    setPlayGame(gameUrl);
                                    setLoading(false);
                                });
                            })
                            .catch((err) => {
                                localStorage.setItem("playing_product", params.product_type);
                                window.history.pushState({ inGame: true }, "");
                                setPlayGame(gameUrl);
                                setLoading(false);
                            });
                    } else {
                        localStorage.setItem("playing_product", params.product_type);
                        window.history.pushState({ inGame: true }, "");
                        setPlayGame(gameUrl);
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    swal("Sảnh đang bảo trì", "Vui lòng chọn game khác", "error");
                }
            })
            .catch((err) => {
                setLoading(false);
                if (err.response?.data?.data?.tokenVerificationData?.access === false) {
                    swal("Đã xảy ra lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error");
                    return;
                }
                swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra", "error");
            });
    }

    // ĐÓNG GAME VÀ RÚT TIỀN
    const handleCloseGame = () => {
        setLoading(true);
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: product })
            .then((res) => {
                const currentBalance = res.data.data.balance;
                if (currentBalance > 0) {
                    const autoWithdrawData = {
                        product_type: product,
                        type: 2,
                        money: Math.floor(currentBalance)
                    };
                    return axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, autoWithdrawData);
                }
                return Promise.resolve();
            })
            .then(() => axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`))
            .then((res) => {
                if (res && res.data && res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
                localStorage.removeItem("playing_product");
                setPlayGame(null);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                setPlayGame(null);
                swal("Thông báo", "Hệ thống đang xử lý lệnh kết toán muộn. Vui lòng kiểm tra lại số dư ví tổng sau ít phút.", "warning");
            });
    };

    // LOGIC PHÂN TRANG & LỌC TÌM KIẾM
    const filteredGames = game && game.length > 0 
        ? game.filter(item => item.gameName.toLowerCase().includes(searchTerm.toLowerCase()))
        : [];
        
    const totalPages = Math.ceil(filteredGames.length / gamesPerPage);
    const indexOfLastGame = currentPage * gamesPerPage;
    const indexOfFirstGame = indexOfLastGame - gamesPerPage;
    const currentGames = filteredGames.slice(indexOfFirstGame, indexOfLastGame);

    return (
        <>
            <Header profile={profile} />

            <style>{`
                /* NỀN DARK THEME CHUẨN MỰC */
                .pvp-page-wrapper {
                    background-color: #1b1e36;
                    min-height: 100vh;
                    font-family: 'Montserrat', sans-serif;
                    padding-bottom: 50px;
                    position: relative;
                }

                /* BANNER FULL WIDTH */
                .pvp-banner-container {
                    width: 100%;
                    overflow: hidden;
                    display: flex;
                    justify-content: center;
                    background-color: #1f2133;
                }
                .pvp-banner-container img {
                    width: 100%;
                    max-width: 1515px;
                    height: auto;
                    display: block;
                    object-fit: cover;
                }

                /* CONTAINER CHÍNH */
                .pvp-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 15px 20px;
                }

                /* 1. THANH MENU CÁC NHÀ CUNG CẤP DẠNG KHỐI TÁCH RỜI */
                .providers-nav-bar {
                    display: flex;
                    align-items: flex-end;
                    overflow-x: auto;
                    scrollbar-width: none;
                    gap: 6px; 
                    margin-top: -30px; /* Đè 1 phần lên banner */
                    position: relative;
                    z-index: 10;
                }
                .providers-nav-bar::-webkit-scrollbar { display: none; }
                
                .provider-btn {
                    flex: 1;
                    min-width: 120px;
                    height: 75px;
                    background-color: #2b3052;
                    border: none;
                    border-radius: 12px 12px 0 0; 
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    color: #8da4d0;
                    font-size: 13px;
                    font-weight: 700;
                    padding: 10px 0;
                    box-shadow: 0 -4px 10px rgba(0,0,0,0.2);
                }
                .provider-btn:hover {
                    background-color: #3b426e;
                    color: #fff;
                }
                .provider-btn.active {
                    background-color: #3b426e;
                    color: #00e5ff;
                    border-bottom: 3px solid #00e5ff; /* Vạch sáng báo hiệu đang chọn */
                }
                .provider-btn img {
                    max-width: 80px;
                    max-height: 30px;
                    object-fit: contain;
                    margin-bottom: 5px;
                    filter: grayscale(100%) opacity(0.7); /* Mặc định tối */
                    transition: all 0.3s ease;
                }
                .provider-btn:hover img, .provider-btn.active img {
                    filter: grayscale(0%) opacity(1); /* Sáng lên khi chọn */
                }

                /* 2. THANH CÔNG CỤ (TÌM KIẾM, LỌC) */
                .pvp-toolbar {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin: 25px 0;
                    flex-wrap: wrap;
                    gap: 15px;
                    border-bottom: 1px solid #2a2e4a;
                    padding-bottom: 15px;
                }
                .toolbar-left {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    flex-wrap: wrap;
                }
                .toolbar-tab {
                    color: #8da4d0;
                    font-size: 14px;
                    cursor: pointer;
                    transition: 0.2s;
                }
                .toolbar-tab:hover, .toolbar-tab.active {
                    color: #00e5ff;
                    font-weight: bold;
                }
                
                .toolbar-right {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                }
                .search-box {
                    display: flex;
                    align-items: center;
                    background-color: #24294d;
                    border: 1px solid #3a3f63;
                    border-radius: 20px;
                    padding: 6px 15px;
                    width: 250px;
                }
                .search-box input {
                    border: none;
                    background: transparent;
                    outline: none;
                    flex: 1;
                    padding: 5px;
                    font-size: 13px;
                    color: #fff;
                    font-family: 'Montserrat', sans-serif;
                }
                .search-box input::placeholder {
                    color: #6a7c9f;
                }
                .search-box svg {
                    color: #6a7c9f;
                    cursor: pointer;
                }

                /* 3. LƯỚI HIỂN THỊ GAME BÀI */
                .pvp-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
                    gap: 20px;
                }
                .pvp-card {
                    background: #24294d;
                    border-radius: 10px;
                    overflow: hidden;
                    cursor: pointer;
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    display: flex;
                    flex-direction: column;
                    border: 1px solid #3a3f63;
                }
                .pvp-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 8px 20px rgba(0, 229, 255, 0.2); /* Sáng viền xanh ngọc */
                    border-color: #00e5ff;
                }
                .pvp-img-wrapper {
                    position: relative;
                    width: 100%;
                    aspect-ratio: 1/1;
                    background-color: #1a1c38;
                    overflow: hidden;
                }
                .pvp-img-wrapper img.game-thump {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                    transition: transform 0.3s ease;
                }
                .pvp-card:hover img.game-thump {
                    transform: scale(1.05); /* Phóng to ảnh nhẹ khi đưa chuột vào */
                }

                /* OVERLAY NÚT CHƠI THỬ / CHƠI NGAY */
                .pvp-action-overlay {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    padding: 10px;
                    background: linear-gradient(to top, rgba(0,0,0,0.9) 0%, transparent 100%);
                    display: flex;
                    justify-content: space-between;
                    gap: 5px;
                    opacity: 0;
                    transform: translateY(10px);
                    transition: all 0.3s ease;
                    box-sizing: border-box;
                }
                .pvp-card:hover .pvp-action-overlay {
                    opacity: 1;
                    transform: translateY(0);
                }
                .btn-try, .btn-play {
                    flex: 1;
                    padding: 6px 0;
                    font-size: 11px;
                    font-weight: bold;
                    border-radius: 15px;
                    text-align: center;
                    border: 1px solid #00e5ff;
                }
                .btn-try {
                    background: transparent;
                    color: #00e5ff;
                }
                .btn-try:hover {
                    background: rgba(0, 229, 255, 0.2);
                }
                .btn-play {
                    background: #00e5ff;
                    color: #000;
                }
                .btn-play:hover {
                    background: #00b8cc;
                }

                .pvp-title {
                    padding: 12px 10px;
                    font-size: 13px;
                    color: #fff;
                    text-align: center;
                    font-weight: 600;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                /* PHÂN TRANG (Pagination) */
                .pagination-container {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 15px;
                    margin-top: 40px;
                }
                .page-btn {
                    padding: 8px 16px;
                    background-color: transparent;
                    border: 1px solid #00e5ff;
                    color: #00e5ff;
                    border-radius: 20px;
                    font-size: 13px;
                    font-weight: bold;
                    cursor: pointer;
                    transition: all 0.2s;
                }
                .page-btn:hover:not(:disabled) {
                    background-color: #00e5ff;
                    color: #000;
                }
                .page-btn:disabled {
                    border-color: #3a3f63;
                    color: #6a7c9f;
                    cursor: not-allowed;
                }
                .page-info {
                    font-weight: bold;
                    color: #fff;
                    font-size: 14px;
                }

                @media (max-width: 768px) {
                    .pvp-grid {
                        grid-template-columns: repeat(3, 1fr);
                        gap: 15px;
                    }
                    .search-box {
                        width: 100%;
                    }
                    .pvp-action-overlay {
                        opacity: 1;
                        transform: translateY(0);
                        padding: 5px;
                    }
                    .btn-try, .btn-play { font-size: 10px; }
                }
                @media (max-width: 480px) {
                    .pvp-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }
                }
            `}</style>

            {isLoading === true ? (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            ) : null}

            <div className="pvp-page-wrapper">
                
                {/* BANNER THIÊN ĐƯỜNG GAME GIẢI TRÍ */}
                <div className="pvp-banner-container">
                    <img src="https://i.ibb.co/hRNRGBY4/1762765187295-Thi-n-ng-gi-i-tr.jpg" alt="Banner Game Bài" />
                </div>

                <div className="pvp-container">

                    {/* 1. THANH MENU NHÀ CUNG CẤP */}
                    <div className="providers-nav-bar">
                        <button className={`provider-btn ${activeOption === "0" ? "active" : ""}`} onClick={() => handleOptionClick("0", "102", "PVP")}>
                            <img src={require("../../image/common/icon-v8.png")} alt="V8 POKER" />
                            <span>V8 Poker</span>
                        </button>
                        <button className={`provider-btn ${activeOption === "1" ? "active" : ""}`} onClick={() => handleOptionClick("1", "121", "PVP")}>
                            <img src={require("../../image/common/icon-km.png")} alt="KINGMAKER" />
                            <span>KingMaker</span>
                        </button>
                        <button className={`provider-btn ${activeOption === "3" ? "active" : ""}`} onClick={() => handleOptionClick("3", "140", "PVP")}>
                            <img src={require("../../image/common/icon-jili.png")} alt="JILI" />
                            <span>Jili</span>
                        </button>
                    </div>

                    {/* 2. THANH LỌC VÀ TÌM KIẾM */}
                    <div className="pvp-toolbar">
                        
                        <div className="toolbar-right">
                            <div className="search-box">
                                <input 
                                    type="text" 
                                    placeholder="Vui lòng nhập tên trò chơi..." 
                                    value={searchTerm}
                                    onChange={handleSearch}
                                />
                                <SearchIcon fontSize="small" />
                            </div>
                        </div>
                    </div>

                    {/* 3. LƯỚI HIỂN THỊ GAME */}
                    <div className="pvp-grid">
                        {currentGames.length > 0 ? (
                            currentGames.map((item, index) => (
                                <div key={index} className="pvp-card" onClick={() => launchGame({ product_type: item.productType, game_code: item.tcgGameCode })}>
                                    <div className="pvp-img-wrapper">
                                        <img
                                            className="game-thump"
                                            src={`https://images.21947392.com/TCG_GAME_ICONS/${item.productCode}/VI/${item.tcgGameCode}.png`}
                                            onError={(e) => handleImageError(e)}
                                            alt={item.gameName}
                                        />
                                        
                                        {/* Overlay Nút Chơi Thử / Chơi Ngay */}
                                        <div className="pvp-action-overlay">
                                            <div className="btn-try">Chơi thử</div>
                                            <div className="btn-play">Chơi ngay</div>
                                        </div>
                                    </div>
                                    <div className="pvp-title" title={item.gameName}>{item.gameName}</div>
                                </div>
                            ))
                        ) : (
                            !isLoading && <p style={{ gridColumn: "1/-1", textAlign: "center", color: "#6a7c9f", marginTop: "20px" }}>Không tìm thấy game nào.</p>
                        )}
                    </div>

                    {/* 4. PHÂN TRANG (PAGINATION) */}
                    {totalPages > 1 && (
                        <div className="pagination-container">
                            <button 
                                className="page-btn" 
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                            >
                                &laquo; Trang trước
                            </button>
                            <span className="page-info">Trang {currentPage} / {totalPages}</span>
                            <button 
                                className="page-btn" 
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                            >
                                Trang tiếp &raquo;
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* IFRAME HIỂN THỊ GAME */}
            {playGame ? (
                <div
                    className="iframe-game-backdrop"
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "#000",
                        zIndex: 99999,
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <div style={{
                        width: "100%",
                        height: "50px",
                        backgroundColor: "#162a35",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0 15px",
                        boxSizing: "border-box"
                    }}>
                        <div style={{
                            color: "#00e5ff",
                            fontWeight: "bold",
                            fontSize: "18px",
                            fontFamily: "sans-serif"
                        }}>
                            Game Bài {sanh}
                        </div>
                        <button
                            onClick={handleCloseGame}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "4px",
                                backgroundColor: "#ff5050",
                                color: "#fff",
                                border: "none",
                                borderRadius: "20px",
                                padding: "6px 16px",
                                fontSize: "14px",
                                fontWeight: "600",
                                cursor: "pointer"
                            }}
                        >
                            <CloseIcon sx={{ fontSize: "18px" }} /> Thoát
                        </button>
                    </div>

                    <iframe
                        src={playGame}
                        title={`Game Bài ${sanh}`}
                        style={{
                            width: "100%",
                            flexGrow: 1,
                            border: "none"
                        }}
                        allowFullScreen
                    ></iframe>
                </div>
            ) : null}
        </>
    );
}

export default Pvp;